import {
	db,
	IModel,
	IVIPProjectIpBase,
	VIPIpCertificate,
	VIPProjectIpBase,
} from "@/loader";

/**
 * Project IP Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.2.0
 * @since		1.0.0
 */
export interface IVIPProjectIp extends IVIPProjectIpBase {
}

/**
 * Project IP Class.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.2.0
 * @since		1.0.0
 */
export class VIPProjectIp extends VIPProjectIpBase implements IVIPProjectIp, IModel<IVIPProjectIp> {
	constructor (data: IVIPProjectIp = {}) {
		super(data);
	}

	public load(data: IVIPProjectIp) {
		super.load(data);
	}

	public update(data: IVIPProjectIp) {
		super.update(data);
	}

	public get ipCertificate(): VIPIpCertificate | null {
		return db.ipCertificates.list.find(ipc => ipc.fk_project === this.fk_project && ipc.fk_ip === this.fk_ip) || null;
	}
}
